import styled from 'styled-components';
import { Booleanish } from 'ia-react-core/~/interfaces/Booleanish';

const CHECKBOX_SIZE = 18;
const CHECK_SIZE = 22;

export const StyledHiddenCheckbox = styled.input`
  opacity: 0;
  position: absolute;
  width: ${CHECKBOX_SIZE}px;
  height: ${CHECKBOX_SIZE}px;
  z-index: 1;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
`;

export const StyledIcon = styled.svg`
  position: absolute;
  width: ${CHECK_SIZE}px;
  height: ${CHECK_SIZE}px;
  color: ${({ theme }) => theme.colors.white};
  visibility: hidden;
`;
export const StyledCheck = styled(StyledIcon)`
  top: -2px;
  left: -3px;
`;

export const StyledIndeterminateCheck = styled(StyledIcon)`
  top: -2px;
  left: -2px;
`;

export const StyledCheckbox = styled.span<{
  focusable: Booleanish;
  color: string;
}>`
  position: relative;
  display: inline-block;
  width: ${CHECKBOX_SIZE}px;
  height: ${CHECKBOX_SIZE}px;
  border-radius: 2px;
  border: 2px solid ${({ theme, color }) => color || theme?.Checkbox?.borderColor || theme.colors.gray5};;
  line-height: 1;
  box-sizing: border-box;
  background: transparent;
  overflow: hidden;
`;

export const StyledCheckboxButtonWrapper = styled.span`
  display: inline-block;
  width: ${CHECKBOX_SIZE}px;
  height: ${CHECKBOX_SIZE}px;

  input:not(:disabled) + &:hover {
    ${StyledCheckbox} {
      border-color: ${({ theme }) => theme?.Checkbox?.hoverOutlineColor};
    }
  }

  input:checked + & {
    ${StyledCheckbox} {
      background-color: ${({ theme }) => theme?.Checkbox?.checkedColor || theme.colors.light};
      border: 0;

      ${StyledCheck} {
        visibility: visible;
      }
    }
  }

  input:indeterminate + & {
    ${StyledCheckbox} {
      background-color: ${({ theme }) => theme?.Checkbox?.checkedColor || theme.colors.light};
      border: 0;

      ${StyledIndeterminateCheck} {
        visibility: visible;
      }
    }
  }

  input:focus + &.ia-react-core__checkbox--focus {
    ${StyledCheckbox} {
      box-shadow: ${({ theme }) => theme.colors.focus} 0 0 3px 2px;
      border-color: ${({ theme }) => theme.colors.focus};
    }
  }

  input:disabled + & {
    ${StyledCheckbox} {
      background: ${({ theme }) => theme?.Checkbox?.disabledBackground};
      border-color: ${({ theme }) => theme.colors.shadowGray1};
    }
  }

  input:disabled:checked + & {
    ${StyledCheckbox} {
      background: ${({ theme }) => theme.colors.shadowGray1};
    }
  }
`;
